const preloadedImages = {};

export const Preload = (src) => {
    preloadedImages[src] = new Image();
    preloadedImages[src].src = src;
}